module.exports = __webpack_public_path__ + "static/media/introduction.d56381c9.svg";